import { Time } from '@internationalized/date';

const TIME_PATTERN = /^(\d{1,2}):(\d{2})(?::[0-5]\d(?:\.\d+)?)?$/;

export const parseTimeValue = (value: string | undefined) => {
  const match = TIME_PATTERN.exec(value?.trim() ?? '');
  if (!match) {
    return null;
  }

  const hour = Number(match[1]);
  const minute = Number(match[2]);
  if (hour > 23 || minute > 59) {
    return null;
  }

  return new Time(hour, minute);
};

export const formatTimeValue = ({ hour, minute }: { hour: number; minute: number }) =>
  `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
